<template>
    <div class="swiper-container">
        <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="item in banner" :key="item.id"
                 @click="$fn.toPage(item.url)">
<!--                height="auto"-->
                <img :src="item.pic" width="100%" :height="!phone?'auto':''" :style="phone?'height: 7rem;':''" alt="">
            </div>
        </div>
        <!-- Add Pagination -->
        <div v-if="banner.length > 1" class="swiper-pagination"></div>
    </div>
</template>

<script>
    export default {
        name: 'banner',
        props: {
            type: {
                default: 1
            },
            phone:{
                default: false
            }
        },
        data() {
            return {
                banner: []
            }
        },
        async mounted() {
            await this.getBanner()
            this.swiperInit()
        },
        methods: {
            swiperInit() {
                var swiper = new Swiper('.swiper-container', {
                    loop: this.banner.length>1,
                    pagination: '.swiper-pagination',
                    paginationClickable: true,
                    speed: 1000,//匀速时间
                    autoplay: 4000,
                });
            },
            // 获取首页轮播图
            async getBanner() {
                this.banner = await this.$api.getBanner({type: this.type})
            },
        },

    }
</script>
<style scoped lang="scss">
    .swiper-container1 {
        .swiper-wrapper {
            transition-timing-function: linear !important;
        }
    }
</style>
